/**
 * Copier vers src/utils/http.ts sur la branche prod-catalogue avant push.
 * cp deploy/http.prod-catalogue.ts src/utils/http.ts
 */
type ENV = "local" | "dev" | "prod" | "demo";

export const currentEnv: ENV = "prod";

const API_DEV_URL = "https://api.dev.easymarket.sn";
const API_DEMO_URL = "https://api.recette.dev.easymarket.sn";
const API_PROD_URL = "https://api.easymarket.sn";
const API_LOCAL_URL = "http://127.0.0.1:8000";

const VENDEUR_APIKEY_DEMO = "";
const VENDEUR_APIKEY_PROD = "";

export const APP_URL_LOCAL = "http://localhost:3000";
export const APP_URL_DEV = "https://dev.easymarket.sn";
export const APP_URL_DEMO = "https://catalogue.recette.dev.easymarket.sn";
export const APP_URL_PROD = "https://catalogue.easymarket.sn";

function isBrowserLocalhost(): boolean {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

export function getRuntimeEnv(): ENV {
  if (isBrowserLocalhost()) return "local";
  return currentEnv;
}

function processApiUrl(runtime: ENV) {
  if (runtime === "local") return API_LOCAL_URL;
  if (runtime === "prod") return API_PROD_URL;
  if (runtime === "demo") return API_DEMO_URL;
  return API_DEV_URL;
}

function processAppUrl(runtime: ENV) {
  if (runtime === "local") return APP_URL_LOCAL;
  if (runtime === "prod") return APP_URL_PROD;
  if (runtime === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processApikey(runtime: ENV) {
  if (runtime === "local") return "";
  if (runtime === "prod") return VENDEUR_APIKEY_PROD;
  return VENDEUR_APIKEY_DEMO;
}

const runtimeEnv = getRuntimeEnv();

export const Env = runtimeEnv;
export const ApiBaseUrl = processApiUrl(runtimeEnv);
export const AppBaseUrl = processAppUrl(runtimeEnv);
export const VendeurApikey = processApikey(runtimeEnv);

export const GoogleApikey = "AIzaSyChXWZKmUgaWFvIV2WnTVoR2IY3-uhReBg";
export const IntechApikey = "";
export const GoogleClientId =
  "701177325323-33rje48k1alj39qmb9vspat9urmmrojn.apps.googleusercontent.com";

export function buildVendorCatalogUrl(shopSlug: string): string {
  const base = AppBaseUrl.replace(/\/$/, "");
  return `${base}/catalogue/${shopSlug}`;
}
